const style = {
  container: {
    width: "100%",
    padding: "20px",
    color: "#E6EDF3",
  },
  loadingContainer: {
    color: "white",
    textAlign: "center",
    padding: "50px",
    fontSize: "18px",
  },
  header: {
    marginBottom: "40px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: "32px",
    fontWeight: "600",
    margin: "0 0 4px 0",
    background: "linear-gradient(90deg, #58A6FF, #A371F7)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  subtitle: {
    fontSize: "16px",
    color: "#8B949E",
    margin: 0,
  },
  createButton: {
    backgroundColor: '#238636',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "20px",
    marginBottom: "40px",
  },
  statCard: {
    backgroundColor: "rgba(22, 27, 34, 0.6)",
    border: "1px solid #30363D",
    borderRadius: "12px",
    padding: "20px",
    backdropFilter: "blur(5px)",
  },
  statLabel: {
    fontSize: "14px",
    color: "#8B949E",
    margin: "0 0 8px 0",
  },
  statValue: {
    fontSize: "28px",
    fontWeight: "bold",
    margin: 0,
  },
  listContainer: {
    backgroundColor: "rgba(22, 27, 34, 0.8)",
    border: "1px solid #30363D",
    borderRadius: "16px",
    overflow: "hidden",
  },
  table: {
    width: "100%",
  },
  tableRow: {
    display: "grid",
    gridTemplateColumns: "2.5fr 1.5fr 1fr 1fr 1fr",
    alignItems: "center",
    padding: "16px 24px",
    borderBottom: "1px solid #30363D",
    transition: "background-color 0.2s ease, transform 0.2s ease",
    cursor: "pointer",
  },
  tableHeader: {
    color: "#8B949E",
    fontSize: "12px",
    textTransform: "uppercase",
    fontWeight: "600",
    cursor: "default",
  },
  "tableRow:hover": {
    backgroundColor: "rgba(88, 166, 255, 0.05)",
    transform: "scale(1.01)",
  },
  "tableRow:last-child": {
    borderBottom: "none",
  },
  tableCell: {
    fontSize: "14px",
  },
  clientInfo: {
    display: "flex",
    flexDirection: "column",
  },
  clientName: {
    fontWeight: "600",
    fontSize: "15px",
  },
  clientCnpj: {
    color: "#8B949E",
    fontSize: "12px",
  },
  valueCell: {
    fontWeight: "600",
    color: "#34D399",
  },
  textCenter: {
    textAlign: "center",
  },
  statusBadge: {
    padding: "4px 12px",
    borderRadius: "9999px",
    fontSize: "12px",
    fontWeight: "600",
    display: "inline-block",
  },
  statusActive: {
    backgroundColor: "rgba(4, 120, 87, 0.3)",
    color: "#34D399",
  },
  statusPending: {
    backgroundColor: "rgba(217, 119, 6, 0.3)",
    color: "#FBBF24",
  },
  statusBlocked: {
    backgroundColor: "rgba(153, 27, 27, 0.3)",
    color: "#F87171",
  },
  noResults: {
    textAlign: "center",
    padding: "40px",
    color: "#8B949E",
  },
};

export default style;